import React, { useEffect, useState } from 'react';
import { Building2, Euro, FileWarning, Grape, Loader2, Sprout, Wine } from 'lucide-react';
import api from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';

const eur = (v) => (v || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
const nb = (v) => (v || 0).toLocaleString('fr-FR');

function Kpi({ icon: Icon, label, valeur, testid }) {
  return (
    <Card><CardContent className="p-4 flex items-center gap-3">
      <div className="p-2 rounded-lg bg-emerald-50"><Icon className="w-5 h-5 text-emerald-700" /></div>
      <div><p className="text-xs text-stone-500">{label}</p><p className="text-xl font-semibold" data-testid={testid}>{valeur}</p></div>
    </CardContent></Card>
  );
}

const COLONNES = [
  ['surface_ha', 'Surface', (v) => `${nb(v)} ha`], ['traitements_annee', 'Traitements', nb],
  ['volume_cave_hl', 'En cave', (v) => `${nb(v)} hl`], ['bouteilles_stock', 'Bouteilles', nb],
  ['ca_caveau_ttc', 'Caveau', eur], ['ca_factures_ttc', 'Facturé', eur], ['factures_impayees', 'À encaisser', nb],
  ['etiquettes_non_conformes', 'Étiquettes à corriger', nb],
];

export default function VueGroupePage() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/vue-groupe').then((r) => setD(r.data)).catch(() => setD({ societes: [], total: {} })); }, []);
  if (!d) return <div className="p-8"><Loader2 className="w-6 h-6 animate-spin text-stone-400" /></div>;
  const t = d.total;
  return (
    <div className="p-4 md:p-8 space-y-6" data-testid="vue-groupe">
      <div>
        <h1 className="text-3xl font-semibold text-stone-900">Vue groupe</h1>
        <p className="text-sm text-stone-500 mt-1">Toutes vos sociétés réunies : vignes, cave, caveau, facturation et conformité.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Kpi icon={Sprout} label="Surface totale" valeur={`${nb(t.surface_ha)} ha`} testid="groupe-surface" />
        <Kpi icon={Wine} label="Volume en cave" valeur={`${nb(t.volume_cave_hl)} hl`} testid="groupe-cave" />
        <Kpi icon={Euro} label="Chiffre d'affaires (factures + caveau)" valeur={eur((t.ca_factures_ttc || 0) + (t.ca_caveau_ttc || 0))} testid="groupe-ca" />
        <Kpi icon={FileWarning} label="Étiquettes à corriger · factures à encaisser" valeur={`${nb(t.etiquettes_non_conformes)} · ${nb(t.factures_impayees)}`} testid="groupe-alertes" />
      </div>
      <Card><CardContent className="p-0 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-stone-500 border-b bg-stone-50">
            <th className="p-3">Société</th>{COLONNES.map(([k, l]) => <th key={k} className="p-3 whitespace-nowrap">{l}</th>)}
          </tr></thead>
          <tbody>
            {d.societes.map((s) => (
              <tr key={s.id} className="border-b" data-testid={`groupe-societe-${s.id}`}>
                <td className="p-3"><div className="flex items-center gap-2">{s.type === 'cave' ? <Building2 className="w-4 h-4 text-purple-600" /> : <Grape className="w-4 h-4 text-emerald-700" />}
                  <div><div className="font-medium">{s.nom}</div><div className="text-xs text-stone-500">{s.groupe ? `${s.groupe} · ` : ''}{s.ville}</div></div></div></td>
                {COLONNES.map(([k, , f]) => <td key={k} className="p-3 whitespace-nowrap">{f(s[k])}</td>)}
              </tr>
            ))}
            <tr className="font-semibold bg-emerald-50/50" data-testid="groupe-total">
              <td className="p-3">Total</td>{COLONNES.map(([k, , f]) => <td key={k} className="p-3 whitespace-nowrap">{f(t[k])}</td>)}
            </tr>
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
